import { render, staticRenderFns } from "./OutLinkNew.vue?vue&type=template&id=231e97a4&scoped=true&"
import script from "./OutLinkNew.vue?vue&type=script&lang=js&"
export * from "./OutLinkNew.vue?vue&type=script&lang=js&"
import style0 from "./OutLinkNew.vue?vue&type=style&index=0&id=231e97a4&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "231e97a4",
  null
  
)

export default component.exports